import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: JSON.parse(localStorage.getItem('user')) || null,
  isLoading: false,
  error: null,
  resetLoading: false,
  resetError: null,
  changeLoading: false,
  changeError: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoading = false;
      state.user = action.payload.data.user;
      localStorage.setItem('token', action.payload.data.token);
      localStorage.setItem('user', JSON.stringify(state.user));
    },
    loginFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
    },
    logout: (state) => {
      state.user = null;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('selectedDriveRow');
      localStorage.removeItem('createDriveFromCollection');
    },
    resetStart: (state) => {
      state.resetLoading = true;
      state.resetError = null;
    },
    resetSuccess: (state) => {
      state.resetLoading = false;
      state.resetError = null;
    },
    resetFailure: (state, action) => {
      state.resetLoading = false;
      state.resetError = action.payload.message;
    },
    changeStart: (state) => {
      state.changeLoading = true;
      state.changeError = null;
    },
    changeSuccess: (state) => {
      state.changeLoading = false;
      state.changeError = null;
    },
    changeFailure: (state, action) => {
      state.changeLoading = false;
      state.changeError = action.payload.message;
    },
    forgotStart: (state) => {
      state.forgotLoading = true;
      state.forgotError = null;
    },
    forgotSuccess: (state) => {
      state.forgotLoading = false;
      state.forgotError = null;
    },
    forgotFailure: (state, action) => {
      state.forgotLoading = false;
      state.forgotError = action.payload.message;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  resetStart,
  resetSuccess,
  resetFailure,
  changeStart,
  changeSuccess,
  changeFailure,
  forgotStart,
  forgotSuccess,
  forgotFailure,
} = authSlice.actions;

export default authSlice.reducer;
